module.exports = __webpack_public_path__ + "static/media/productman.28fe5139.png";